import { create } from 'zustand';
import type { PlannerBoard, PlannerCard } from '../services/api';

/** Where a board came from: which plan, through which account or shared canvas. */
export interface PlannerSource {
  planId: string;
  account?: string;
  canvas: string | null;
}

/** The Planner task open in the details pop-up (components/PlannerTaskModal.tsx), if any. */
export const usePlannerTask = create<{
  open: { task: PlannerCard; board: PlannerBoard; source: PlannerSource } | null;
  show: (task: PlannerCard, board: PlannerBoard, source: PlannerSource) => void;
  close: () => void;
}>()((set) => ({
  open: null,
  show: (task, board, source) => set({ open: { task, board, source } }),
  close: () => set({ open: null }),
}));
